export const AppMonitoringSymbol = Symbol('AppMonitoring')

export const name = 'appMonitoring' as const
